import React from 'react';
import {
  Heading1, Bold, Paragraph, LinkStyled,
} from '../components/typography';
import { Container, Row, Col } from '../components/grid';
import { Image } from '../components/Image';
import FullWidthLayout from '../layout/DefaultLayout/Layouts/FullWidthLayout';

export default () => (
  <FullWidthLayout>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading1>Links til lokaler, underholdning og mad m.m.</Heading1>
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <Col xs={12} grey h100p textCenter>
            <Paragraph>
              <LinkStyled external to="https://meddethele.dk/">
                <Image name="links.meddethele.png" alt="meddethele.dk" title="meddethele.dk" />
              </LinkStyled>
            </Paragraph>
            <Paragraph fontSize="16px"><Bold>Pølsevogn til dit event</Bold></Paragraph>
            <Paragraph>
              Lej en pølsevogn til din fest hos <LinkStyled external to="https://meddethele.dk/">meddethele.dk</LinkStyled>
            </Paragraph>
          </Col>
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <Col xs={12} grey h100p textCenter>
            <Paragraph>
              <LinkStyled external to="http://www.sodavand.dk/">
                <Image name="links.sodavand.png" alt="sodavand.dk" title="sodavand.dk" />
              </LinkStyled>
            </Paragraph>
            <Paragraph fontSize="16px"><Bold>Sodavandsautomater</Bold></Paragraph>
            <Paragraph>
              Gratis udlejning af sodavandsautomater i storkøbenhavn <LinkStyled external to="http://www.sodavand.dk/">sodavand</LinkStyled>
            </Paragraph>
          </Col>
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <Col xs={12} grey h100p textCenter>
            <Paragraph>
              <LinkStyled external to="http://www.grillcatering.dk/">
                <Image name="links.grillcatering.png" alt="Grillcatering" title="Grillcatering" />
              </LinkStyled>
            </Paragraph>
            <Paragraph fontSize="16px"><Bold>Catering - Grill</Bold></Paragraph>
            <Paragraph>
              Skal du have mad til dit arrangement? Så prøv en lækker grill buffet fra <LinkStyled external to="http://www.grillcatering.dk/">grillcatering.dk</LinkStyled>.
            </Paragraph>
          </Col>
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
          <Col xs={12} grey h100p textCenter>
            <Paragraph>
              <LinkStyled external to="http://draftmore.com/index.php?option=com_content&view=article&id=99&Itemid=191&lang=da">
                <Image name="links.drink-more.png" alt="Drink More" title="Drink More" />
              </LinkStyled>
            </Paragraph>
            <Paragraph fontSize="16px"><Bold>Termoregulatorer</Bold></Paragraph>
            <Paragraph>Selvregulerende til fadøl.</Paragraph>
            <Paragraph><LinkStyled external to="http://draftmore.com/index.php?option=com_content&view=article&id=99&Itemid=191&lang=da">www.draftmore.com</LinkStyled></Paragraph>
          </Col>
        </Col>
        <Col xs={12} sm={6}>
          <Col xs={12} grey h100p textCenter>
            <Paragraph>
              <LinkStyled external to="https://www.hallernes.dk/frokostordning-kobenhavn/">
                <Image name="links.hallernes-smoerrebroed-frokostordning.png" alt="Hallernes frokostordning København" title="Hallernes frokostordning København" />
              </LinkStyled>
            </Paragraph>
            <Paragraph fontSize="16px"><Bold>Hallernes Smørrebrød Frokostordning</Bold></Paragraph>
            <Paragraph>
              Er du på udkig efter en frokostordning i København og omegn med smørrebrød i absolut topklasse? Hos Hallernes Smørrebrød benyttes lokale råvarer og bæredygtige ingredienser som fisk, kød og økologiske æg. De tilbyder en skræddersyet løsning til din arbejdsplads, der giver ny energi til dine kolleger.
            </Paragraph>
            <Paragraph fontSize="16px">Frokostordning i København - Oplev Hallernes Smørrebrød</Paragraph>
            <Paragraph>
              Hallernes Smørrebrød tilbyder <LinkStyled external to="https://www.hallernes.dk/frokostordning-kobenhavn/">frokostordninger</LinkStyled> med fokus på de bedste råvarer og håndværket bag smørrebrødet. De har flere lokationer i København og sørger for, at maden leveres helt frisk til din arbejdsplads. Få skræddersyet en menu, så alle kan få det smørrebrød, de kan lide.
            </Paragraph>
            <Paragraph>
              <LinkStyled external to="https://www.hallernes.dk/frokostordning-kobenhavn/">Hallernes frokostordning København</LinkStyled>
            </Paragraph>
          </Col>
        </Col>
      </Row>
    </Container>
  </FullWidthLayout>
);
